// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2Pc5D","resendInfoText":"OnGoingPaymentBox_resendInfoText__1G806"};